
import {useState,React} from 'react';
import { motion } from 'framer-motion';
import './homepage.css';
import '../App.css';
import BottomBar from './BottomBar';
import './Achievements.css';
import CircularMenu from './CircularMenu';
import VideoModal from './VideoModal';

const handleDownload = () => {
  const link = document.createElement('a');
  link.href = './resume.docx';
  link.download = 'resume.docx';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const Achievements = () => {
  const experiences = [
    {
      description: 'Awarded the Merit Scholarship Computer Science and Engineering (Data Science) for academic year 2022-2023',
      duration: '',
    },
    {
      description: 'Awarded the Merit Scholarship Computer Science and Engineering (Data Science) for academic year 2021-2022',
      duration: '',
    },
    {
      description: 'Qualified Gate 2024',
      duration: '',
    },
    {
      description: '200+ questions solved on Leetcode',
      duration: '',
    },
    {
      description: 'Participated in Smart India Hackathon(2023)',
      duration: '',
    },
    {
      description: 'Participated in WittyHacks 4.0 organized by MLH',
      duration: '',
    },
    {
      description: 'A part of NSS RCOEM (Publicity Head)',
      duration: '',
    },
    // Add more experiences as needed
  ];

  const variants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0 },
  };
  const [showModal, setShowModal] = useState(false);

  const handleOpenModal = () => {
    setShowModal(true);
  }
  
  const handleCloseModal = () => {
    setShowModal(false);
  }
  return (
    <div className="homepagedark">
      <div className="bg1">
        <div className="bg-item"></div>
        {/* <div className="line-group">
          <div className="frame-child5"></div>
          <div className="frame-child5"></div>
          <div className="frame-child5"></div>
          <div className="frame-child5"></div>
          <div className="frame-child5"></div>
          <div className="frame-child5"></div>
        </div> */}
      </div>
      <div className="ololade-group">
        <div className="ololade2">
          <span>AWARDS/ACHIEVEMENTS</span>
          <span className="span2">.</span>
        </div>
        {/* <button className="download-btndark" onClick={handleDownload}>
          <div className="download-btndark-child"></div>
          <div className="download-btndark-item"></div>
          <div className="resume1">Resume</div>
          <img
            className="akar-iconsdownload1"
            alt=""
            src="akariconsdownload.svg"
          />
        </button> */}
      </div>
      <div class="ololade-group">
        <div style={{ position: 'relative', minHeight: '100vh' }}>
  <div style={{
    position: 'absolute',
    top: 5,
    left: 680,
  }}>
    <button class="download-btndark" onClick={handleOpenModal}>
          <div class="download-btndark-child"></div>
          <div class="download-btndark-item"></div>
          <div class="resume1">Visume</div>
          <VideoModal 
        show={showModal} 
        handleClose={handleCloseModal} 
        videoSrc="" 
      />
          {/* <img
            class="akar-iconsdownload1"
            alt=""
            src="akariconsdownload.svg"
          /> */}
        </button>
  </div>
  <div style={{
    position: 'absolute',
    top: 5,
    left: 830,
  }}>
    <button class="download-btndark" onClick={handleDownload}>
          <div class="download-btndark-child"></div>
          <div class="download-btndark-item"></div>
          <div class="resume1">Resume</div>
          <img
            class="akar-iconsdownload1"
            alt=""
            src="akariconsdownload.svg"
          />
        </button>
  </div>
</div>
        
        
      </div>
      <div className="experience-container">
        <h2 className="experience-heading" style={{color: '#0f172a'}}>Work Experience</h2>
        <ul>
        {experiences.map((experience, index) => (
          <motion.div
            key={index}
            initial="hidden"
            animate="visible"
            variants={variants}
            transition={{ duration: 0.6, delay: index * 0.3 }}
            className="experience-card"
          >
            <h3>{experience.duration}</h3>
            <h4>{experience.description}</h4>
          </motion.div>
        ))}
        </ul>
      </div>
      <BottomBar />
      <div style={{ position: 'relative', minHeight: '100vh' }}>
  <div style={{
    position: 'absolute',
    bottom: -5,
    right: 50,
  }}>
    <CircularMenu />
  </div>
</div>
    </div>
  );
};

export default Achievements;
